module.exports = __webpack_public_path__ + "img/Popup_Ethnien.7d421c9c.png";